const locationsMap = document.querySelector('.locations-map');

if (locationsMap) {
  const activeLocation = locationsMap.querySelector('.locations-map-info__location.is-active');
  if (activeLocation) {
    const activeRegion = Array.from(activeLocation.classList).find(
      (region) => !['locations-map-info__location', 'is-active'].includes(region),
    );
    locationsMap.querySelector(`path#${activeRegion}`).classList.add('is-active');
  }

  locationsMap.querySelectorAll('path[id]').forEach((path) => {
    path.addEventListener('click', () => {
      const { id } = path;
      locationsMap.querySelectorAll('.is-active').forEach((el) => el.classList.remove('is-active'));
      locationsMap.querySelectorAll(`.${id}`).forEach((el) => el.classList.add('is-active'));
      path.classList.add('is-active');
    });
  });
}
